import { Link2 } from "lucide-react";
import { useHref, useLocation } from "react-router";

import { cx } from "./cx";
import { useToast } from "./Toast";

/**
 * "Copy link to this view": the page's address with its filters and sort (kept in the URL, PHP-3341),
 * so a teammate opening it sees the same list. Without clipboard access the toast shows the link to
 * copy by hand.
 */
export function CopyLinkButton({ className }: { className?: string }) {
  const toast = useToast();
  const location = useLocation();
  const href = useHref({ pathname: location.pathname, search: location.search });
  const copy = async () => {
    const link = new URL(href, window.location.origin).href;
    try {
      if (!navigator.clipboard) throw new Error("no clipboard");
      await navigator.clipboard.writeText(link);
      toast.show({
        id: "copy-view-link",
        tone: "success",
        title: "Link copied",
        body: "It opens this view.",
      });
    } catch {
      toast.show({
        id: "copy-view-link",
        tone: "warning",
        title: "Couldn't copy the link",
        body: <span className="break-all select-all">{link}</span>,
        duration: null,
      });
    }
  };
  return (
    <button
      type="button"
      onClick={() => void copy()}
      className={cx(
        "inline-flex shrink-0 items-center gap-1.5 rounded-full border border-border bg-surface px-3 py-[7px] text-[12.5px] font-semibold whitespace-nowrap text-fg-muted hover:bg-muted hover:text-fg",
        className,
      )}
    >
      <Link2 className="size-3.5" aria-hidden />
      Copy link to this view
    </button>
  );
}
